import Vue from 'vue'

//only insights show up as tiles
//everybody uses the same viewmodel though

Vue.component('CaseStudyTile', {
  template: '#case-study-tile',
  props: ['link', 'image', 'typeLabel', 'summary']
})